let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ih3hC")).then(() => parcelRequire('5sFi1'));